export default __webpack_public_path__ + "static/media/ansible.b7692ba9.png";